import React from "react";
import { Text } from "@gcs/design-system/react";
import * as S from "./RadioButton.styled";
import { ReactComponent as IconError } from "assets/svgs/rounded-warning.svg";

const RadioButton = ({
  title,
  options,
  selected,
  setSelected,
  hasError,
  errorMessage,
}) => {
  const onCheckHandler = (event) => {
    setSelected((oldValues) => ({
      ...oldValues,
      valid: true,
      value: event.target.value,
    }));
  };
  const radios = options.map((option) => (
    <S.RadioButtonContainer key={option.label} htmlFor={option.label}>
      <S.StyledInput
        type="radio"
        value={option.value}
        onClick={onCheckHandler}
        id={option.label}
        name={option.label}
      />
      <S.RadioButtonArea checked={option.value === selected}>
        <S.RadioButtonControl />
      </S.RadioButtonArea>
      <S.RadioButtonLabel>{option.label}</S.RadioButtonLabel>
    </S.RadioButtonContainer>
  ));

  return (
    <S.GeneralContainer>
      <Text variant="body02-md" size="md">{title}</Text>
      <S.RadioButtonsContainer>{radios}</S.RadioButtonsContainer>
      {hasError && errorMessage && (
        <S.ErrorMessage><IconError />{errorMessage}</S.ErrorMessage>
      )}
    </S.GeneralContainer>
  );
};

export default RadioButton;
